import logo from "../../images/talk.png"


export default function Talk() {
  return (
    <img className="talk" src={logo} alt="contact logo" />
   
  );
}